import React, { useMemo, useRef, useState, useEffect } from "react";
import SinglePolygonAnnotation from "./singlePolygonAnnotation";
import { Stage, Layer, Image } from "react-konva";
import { adjustPolygonPoints } from "../../utils";
import EntryAndExit from "../../pages/Polygon/entryandExit";

const wrapperStyle = {
  display: "flex",
};
const columnStyle = {};
const alertAccordionStyle = {width: 200, height: 128}
const DisplayCanvas = ({
  videoSource,
  imageSize,
  initialPolygons,
  originalSize,
  actionFrom,
  alertAccordion,
}) => {
  const [image, setImage] = useState();
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const imageRef = useRef(null);
  const dataRef = useRef(null);
  const [points, setPoints] = useState([]);
  const [eepoints, setEEPoints] = useState([]);  
  const [size, setSize] = useState({});
  const [flattenedPoints, setFlattenedPoints] = useState();
  const [position, setPosition] = useState([0, 0]);
  const [isMouseOverPoint, setMouseOverPoint] = useState(false);
  const [isPolyComplete, setPolyComplete] = useState(false);
  const [isEntryEixt, setIsEntryEixt] = useState(false);
  let zone1defaultColor = "red";
  let zone2defaultColor = "#0089ECB2";
  let noZoneColor = "#6F7171CC";
  //Entry Exit Color code:
  const [zone2Color, setZone2Color] = useState(zone2defaultColor);
  const [zone1Color, setZone1Color] = useState(zone1defaultColor);
  const [lineColor, setLineColor] = useState("#ffffff");
  const [isPolygonExceedImageBoundary, setIsPolygonExceedImageBoundary] = useState (false);
  const videoElement = useMemo(() => {
    if(videoSource){
      setImageUrl(videoSource);
      const element = new window.Image();
      element.width = imageSize?.width;
      element.height = imageSize?.height;
      element.src = videoSource;
      return element;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoSource]);
  useEffect(() => {
    if(videoElement) {
    setImageLoaded(false);
    const onload = function () {
      setSize({
        width: videoElement.width,
        height: videoElement.height,
      });
      setImage(videoElement);
      imageRef.current = videoElement;
      setImageLoaded(true);
    };
    
    if (videoElement.complete && videoElement.naturalWidth > 0) {
      onload();
    } else {
      videoElement.addEventListener("load", onload);
    }
    
    return () => {
      videoElement.removeEventListener("load", onload);
    };
  }
  }, [videoElement]);
  const getMousePos = (stage) => {
    return [stage.getPointerPosition().x, stage.getPointerPosition().y];
  };
  //drawing begins when mousedown event fires.
  const handleMouseDown = (e) => {
    if (isPolyComplete) return;
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    if (isMouseOverPoint && points.length >= 3) {
      setPolyComplete(true);
    } else {
      // setPoints([...points, mousePos]);
    }
  };
  const handleMouseMove = (e) => {
    const stage = e.target.getStage();
    const mousePos = getMousePos(stage);
    setPosition(mousePos);
  };
  const handleMouseOverStartPoint = (e) => {
    if (isPolyComplete || points.length < 3) return;
    e.target.scale({ x: 3, y: 3 });
    setMouseOverPoint(true);
  };
  const handleMouseOutStartPoint = (e) => {
    e.target.scale({ x: 1, y: 1 });
    setMouseOverPoint(false);
  };
  const handlePointDragMove = (e) => {
    const stage = e.target.getStage();
    const index = e.target.index - 1;
    const pos = [e.target._lastPos.x, e.target._lastPos.y];
    if (pos[0] < 0) pos[0] = 0;
    if (pos[1] < 0) pos[1] = 0;
    if (pos[0] > stage.width()) pos[0] = stage.width();
    if (pos[1] > stage.height()) pos[1] = stage.height();
    setPoints([...points.slice(0, index), pos, ...points.slice(index + 1)]);
  };

  useEffect(() => {
    setFlattenedPoints(
      points
        .concat(isPolyComplete ? [] : position)
        .reduce((a, b) => a.concat(b), [])
    );
  }, [points, isPolyComplete, position]);
  useEffect(() => {
    //const originalSize = [650, 302];
    const newSize = [100, 64];
    if(videoSource) {
      const element = new window.Image();
      element.width = imageSize?.width;
      element.height = imageSize?.height;
      element.src = videoSource;
      setImage(element);
      imageRef.current = element;
    }
   
    setSize({
      width: imageSize?.width,
      height: imageSize?.height,
    });
    
    if(originalSize && originalSize.length && originalSize[0]?.polygon?.direction && originalSize[0]?.polygon?.direction?.splitter) {
      setIsEntryEixt(true);
      setEEPoints(originalSize[0]?.polygon);
    } else {
      const setoriginalSize = [
        originalSize[0]?.polygon?.frame?.maxX
          ? originalSize[0]?.polygon?.frame?.maxX
          : originalSize[0]?.polygon?.polygon?.frame?.maxX ??
            originalSize[0]?.polygon?.polygon?.frame?.maxX,
            originalSize[0]?.polygon?.frame?.maxY
          ? originalSize[0]?.polygon?.frame?.maxY
          : originalSize[0]?.polygon?.polygon?.frame?.maxY ??
            originalSize[0]?.polygon?.polygon?.frame?.maxY
      ];

      const adjustPoints = adjustPolygonPoints(setoriginalSize, initialPolygons, [
        imageSize?.width,
        imageSize?.height,
      ]);
      setPoints(adjustPoints);
  }
    setPolyComplete(true);
  }, [initialPolygons]);
  const undo = () => {
    setPoints(points.slice(0, -1));
    setPolyComplete(false);
    setPosition(points[points.length - 1]);
  };
  const reset = () => {
    setPoints([]);
    setPolyComplete(false);
  };
  const handleGroupDragEnd = (e) => {
    //drag end listens other children circles' drag end event
    //...that's, why 'name' attr is added, see in polygon annotation part
    if (e.target.name() === "polygon") {
      let result = [];
      let copyPoints = [...points];
      copyPoints.map((point) =>
        result.push([point[0] + e.target.x(), point[1] + e.target.y()])
      );
      e.target.position({ x: 0, y: 0 }); //needs for mouse position otherwise when click undo you will see that mouse click position is not normal:)
      setPoints(result);
    }
  };
  return (
    <div style={wrapperStyle}>
      <div style={alertAccordion ? alertAccordionStyle : columnStyle}>
        {!isEntryEixt &&
        <Stage
          width={size.width || 650}
          height={size.height || 302}
          onMouseMove={handleMouseMove}
          onMouseDown={handleMouseDown}
        >
          <Layer>
            <Image
              ref={imageRef}
              image={image}
              x={0}
              y={0}
              width={size.width}
              height={size.height}
            />
            {imageLoaded && <SinglePolygonAnnotation
              points={points}
              flattenedPoints={flattenedPoints}
              handlePointDragMove={handlePointDragMove}
              handleGroupDragEnd={handleGroupDragEnd}
              handleMouseOverStartPoint={handleMouseOverStartPoint}
              handleMouseOutStartPoint={handleMouseOutStartPoint}
              isFinished={isPolyComplete}
            />}
          </Layer>
        </Stage>}
        {isEntryEixt && !actionFrom &&
             <EntryAndExit
             videoSource={imageUrl}
             imageSize={size}
             action="display"
             resetpolygon={eepoints}
             zone2Color={zone2Color}
             zone1Color={zone1Color}
             lineColor={lineColor}
             alertAccordion={alertAccordion}
             setIsPolygonExceedImageBoundary={setIsPolygonExceedImageBoundary}
           />
        }
      </div>
    </div>
  );
};

export default DisplayCanvas;
